/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-sequences */
/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Space, Table, Spin, message, Popover } from 'antd';
import EmptyIcon from '@/assets/empty.png'; // 无数据状态的背景图
import { EmptyFileColor, LogoPatternxGraphicsColor } from 'patternx-svg';
import React, { useState, useRef, useEffect } from 'react';
// 添加公司按钮弹窗组件
import AddComSpace from './addComSpace';
import UpdateComSpace from './updateComSpace';
import TransmitComSpace from './transmitComSpace';
// 创建授权码
import CreateAuthorization from './createAuthorizationCode';
// 成功创建授权码
import SuccessCreateAuCode from './successCreateAuCode';
// 查看授权码
import AuCodeList from './auCodeList';
// 导入接口
import * as api from '@/services/enterprise';
import PtxEmpty from '@/components/ptx-empty';

const ComponySpaceList = () => {
  const [units, setUnits] = useState<any>([]);
  const getTimeUnite = async () => {
    const res = await api.getTimeUnite();
    if (res?.success) {
      setUnits(res?.data?.details || []);
    }
  };

  useEffect(() => {
    // 页面初始化
    getComSpace();
    getPermissionsList();
    // getPerList();
    getTimeUnite();
  }, []);

  // 获取全量企业权限长度
  const [optionsNum, setOptionsNum] = useState(0);
  const [perList, setPerList] = useState([]);
  const getPermissionsList = async () => {
    const res = await api.getPermissionsList('1');
    console.log('更新企业空间获取权限列表', res);

    if (res.code === 200 && res.success) {
      setPerList(res?.data?.details);
      setOptionsNum(res?.data?.details?.length);
    } else {
      message.error('获取企业空间权限列表失败');
    }
  };
  // 搜索公司
  const inputValue = useRef();
  const onInputChange = (e: any) => {
    inputValue.current = e.target.value;
    if (e.target.value === '') {
      console.log('全部删除');
      getComSpace(); // 搜索框内容全部删除时重新获取列表
    }
  };
  const searchUsers = async (value: any) => {
    setTableLoad(true);
    console.log('搜索公司空间', value);
    const res = await api.getEnterpriseListApi({
      // pageIndex: page,
      // pageSize: size,
      queryName: value,
    });
    console.log(res, '公司搜索');
    if (res?.success && res.code === 200) {
      if (res?.data?.size > 0) {
        setPage(res.data.current);
        setData(res?.data?.list);
        setTotal(res?.data?.total);
      } else if (res?.data?.size === 0) {
        // getComSpace(); // 找不到公司时初始化表格
        message.error('未能找到相关企业空间');
        setPage(1);
        setData([]);
        setTotal(0);
      }
    } else {
      message.error('搜索企业空间错误');
      setData([]);
    }
    setTableLoad(false);
  };

  // 打开编辑企业空间
  const [updateComSpaceInfo, setUpdateComSpaceInfo] = useState();

  // 表格参数
  // 表格表头-纵向数据设置
  const columns: any = [
    {
      title: '企业LOGO',
      dataIndex: 'logoStorageUrl',
      key: 'logo',
      width: '8%',
      align: 'center',
      fixed: 'left',
      render: (_: any, record: any) => {
        return (
          <div className="imgLogoBox">
            {record?.logoStorageUrl ? (
              <img src={record?.logoStorageUrl} alt="logo" className="img" />
            ) : (
              <LogoPatternxGraphicsColor size={30} />
            )}
          </div>
        );
      },
    },
    {
      title: '企业空间',
      dataIndex: 'name',
      key: 'name',
      width: '8%',
      align: 'center',
      fixed: 'left',
    },
    {
      title: '所属公司',
      dataIndex: 'companyName',
      key: 'companyName',
      // render: (_: any, record: any) => (
      //     console.log(record, _, 'render'),
      //     <Space size="middle">
      //         {_ === '' ? <span>-</span> : <span>{_}</span>}
      //     </Space>
      // ),
      align: 'center',
    },
    {
      title: '企业拥有者姓名',
      dataIndex: 'ownerName',
      key: 'ownerName',
      // render: (_: any, record: any) => (
      //     console.log(record, _, 'render'),
      //     <Space size="middle">
      //         {_ === '' ? <span>-</span> : <span>{_}</span>}
      //     </Space>
      // ),
      align: 'center',
    },
    {
      title: '企业拥有者手机号',
      dataIndex: 'ownerPhone',
      key: 'ownerPhone',
      // render: (_: any, record: any) => (
      //     console.log(record, _, 'render'),
      //     <Space size="middle">
      //         {_ === '' ? <span>-</span> : <span>{_}</span>}
      //     </Space>
      // ),
      align: 'center',
    },
    {
      title: '企业级应用',
      dataIndex: 'permissionCnt',
      key: 'permissionCnt',
      align: 'center',
      render: (_: any, record: any) => (
        // console.log(record, _, '企业级应用'),
        <Space size="middle">
          <Popover
            content={
              <div>
                {record.permissionDTOList?.length > 0 &&
                  record.permissionDTOList?.map((item: any) => {
                    if ((item.parentId === '' || item.parentId === null) && !item.defaulted) {
                      return (
                        <div style={{ marginBottom: '4px', color: '#868b9c' }}>
                          {item.name || ''}
                        </div>
                      );
                    }
                  })}
              </div>
            }
            title="企业级应用"
            trigger="hover"
          >
            <div
              style={{
                width: '40px',
                height: '24px',
                background: '#f2f3f5',
                textAlign: 'center',
                lineHeight: '24px',
                fontSize: '12px',
                color: '#5f6173',
              }}
            >
              {_}项
            </div>
          </Popover>
        </Space>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'center',
    },
    {
      title: '已购买项目数',
      dataIndex: 'purchaseProjectCnt',
      key: 'purchaseProjectCnt',
      align: 'center',
    },
    {
      title: '定制化',
      dataIndex: 'customize',
      key: 'customize',
      render: (_: any, record: any) => (
        // console.log(record, _, 'render'),
        <Space size="middle">{_ === true ? <span>是</span> : <span>否</span>}</Space>
      ),
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any) => (
        // console.log(record, _, 'render'),
        <Space size="middle">
          <a
            onClick={() => {
              setAddTitle('编辑企业空间');
              setOpenUpdateCompony(true);
              console.log('编辑企业空间record', _, record);
              setUpdateComSpaceInfo(record);
              // setComSpaceInfo({
              //   ...record,
              //   permissionDTOList: record.permissionDTOList,
              //   // permissionDTOList: [
              //   //   ...record.permissionDTOList,
              //   // ],
              // });s
              const logo = record?.logoStorageFileId
                ? [
                    {
                      name: record?.logoFileName,
                      fileUrl: record?.logoStorageUrl || '',
                      fileStorageId: record?.logoStorageFileId || '',
                    },
                  ]
                : [];
              const ico = record?.icoStorageFileId
                ? [
                    {
                      name: record?.icoFileName,
                      fileUrl: record?.icoStorageUrl || '',
                      fileStorageId: record?.icoStorageFileId || '',
                    },
                  ]
                : [];
              const back = record?.backgroundStorageFileId
                ? [
                    {
                      name: record?.backgroundFileName,
                      fileUrl: record?.backgroundStorageUrl || '',
                      fileStorageId: record?.backgroundStorageFileId || '',
                    },
                  ]
                : [];
              setComSpaceInfo({
                ...record,
                logo,
                ico,
                background: back,
              });
              setEnterpriseId(record.id);
            }}
          >
            编辑
          </a>
          <a
            onClick={() => {
              setOpenTransComSpace(true);
              setOwnerInfo({
                ...ownerInfo,
                enterpriseId: record.id,
              });
            }}
          >
            转移
          </a>
          <a
            onClick={() => {
              setOpenCreateAuthorization(true);
              setComSpaceId(record.id); // 企业空间名称
              setComName(record.name);
            }}
          >
            创建授权码
          </a>
          <a
            onClick={() => {
              setOpenAuCodeList(true);
              setComSpaceId(record.id);
              setComName(record.name);
            }}
          >
            查看授权码
          </a>
        </Space>
      ),
      width: 300,
      fixed: 'right',
      align: 'center',
    },
  ];

  // 设置弹窗名字
  const [addTitle, setAddTitle] = useState('');

  // 表格每行横向数据设置
  const [data, setData] = useState([]);

  // 表格加载
  const [tableLoad, setTableLoad] = useState(true);

  // 表格初始化
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量
  const getComSpace = async () => {
    setTableLoad(true);
    const res = await api.getEnterpriseListApi({
      page: page,
      pageSize: size,
      queryName: inputValue.current,
    });
    console.log(res, '企业空间列表初始化');
    if (res?.success && res.code === 200) {
      if (res.data.list.length === 0) {
        message.error('未能找到相关企业空间');
      } else {
        setPage(res.data.pageNum);
        setData(res?.data?.list);
        setTotal(res?.data?.total);
      }
    } else {
      message.error('获取企业空间列表错误');
      setData([]);
    }
    setTableLoad(false);
  };

  // 表格样式设置

  // 添加公司弹窗
  // 打开添加公司
  const [openAddCompony, setOpenAddCompony] = useState(false);
  const [openUpdateCompony, setOpenUpdateCompony] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [comSpaceInfo, setComSpaceInfo] = useState({
    companyId: '',
    customize: false,
    name: '',
    ownerName: '',
    ownerPhone: '',
    permissionDTOList: [],
    logo: [],
    ico: [],
    background: [],
    domainIdentify: '',
  });

  const handleCancel = () => {
    // 关闭弹窗时，清空储存的内容
    setComSpaceInfo({
      companyId: '',
      customize: false,
      name: '',
      ownerName: '',
      ownerPhone: '',
      permissionDTOList: [],
      logo: [],
      ico: [],
      background: [],
      domainIdentify: '',
    });
    setOpenAddCompony(false);
    setOpenUpdateCompony(false);
  };

  const handleOk = async (list: any[]) => {
    setConfirmLoading(true);
    const logo: any = comSpaceInfo?.logo?.[0];
    const ico: any = comSpaceInfo?.ico?.[0];
    const background: any = comSpaceInfo?.background?.[0];
    const res = await api.createEnterpriseApi({
      companyId: comSpaceInfo.companyId,
      customize: comSpaceInfo.customize,
      name: comSpaceInfo.name,
      ownerName: comSpaceInfo.ownerName,
      ownerPhone: comSpaceInfo.ownerPhone,
      permissionDTOList: [
        { name: '企业管理', code: 'sys_manager', status: '1', type: '1' },
        { name: '项目总览', code: 'project_manager', status: '1', type: '1' },
        ...(list || []),
      ],
      domainIdentify: comSpaceInfo?.domainIdentify,
      icoStorageFileId: ico?.fileStorageId || '',
      icoFileName: ico?.name || '',
      logoStorageFileId: logo?.fileStorageId || '',
      logoFileName: logo?.name || '',
      backgroundStorageFileId: background?.fileStorageId || '',
      backgroundFileName: background?.name || '',
    });
    if (res.code === 200 && res.success) {
      console.log('创建企业空间', res, addTitle);
      message.success('企业空间新增成功');
      getComSpace();
      handleCancel();
    }
    // console.log('创建企业空间', comSpaceInfo);
    setConfirmLoading(false);
  };

  const [enterpriseId, setEnterpriseId] = useState('');
  const handleUpdateOk = async (list: any[]) => {
    // setConfirmLoading(true);
    console.log('更新企业空间', comSpaceInfo, list);
    const logo: any = comSpaceInfo?.logo?.[0];
    const ico: any = comSpaceInfo?.ico?.[0];
    const background: any = comSpaceInfo?.background?.[0];
    const res = await api.updateEnterpriseApi({
      companyId: comSpaceInfo.companyId,
      customize: comSpaceInfo.customize,
      name: comSpaceInfo.name,
      ownerName: comSpaceInfo.ownerName,
      ownerPhone: comSpaceInfo.ownerPhone,
      enterpriseId: enterpriseId,
      permissionDTOList: [
        { name: '企业管理', code: 'sys_manager', status: '1', type: '1' },
        { name: '项目总览', code: 'project_manager', status: '1', type: '1' },
        ...(list || []),
      ],
      domainIdentify: comSpaceInfo?.domainIdentify,
      icoStorageFileId: ico?.fileStorageId || '',
      icoFileName: ico?.name || '',
      logoStorageFileId: logo?.fileStorageId || '',
      logoFileName: logo?.name || '',
      backgroundStorageFileId: background?.fileStorageId || '',
      backgroundFileName: background?.name || '',
      // comSpaceInfo.permissionDTOList.length > 0
      //   ? [
      //       { name: '企业管理', code: 'sys_manager', status: '1', type: '1' },
      //       { name: '项目总览', code: 'project_manager', status: '1', type: '1' },
      //       { name: '数字资产库', code: 'digit_asset', status: '1', type: '1' },
      //       ...comSpaceInfo.permissionDTOList,
      //     ]
      //   : [
      //       { code: 'sys_manager', name: '企业管理', status: '1', type: '1' },
      //       { code: 'project_manager', name: '项目总览', status: '1', type: '1' },
      //       { name: '数字资产库', code: 'digit_asset', status: '0', type: '1' },
      //       ...comSpaceInfo.permissionDTOList,
      //     ],
    });
    if (res.code === 200 && res.success) {
      // console.log('编辑企业空间', res, addTitle);
      getComSpace();
      handleCancel();
    }
    // console.log('编辑企业空间', comSpaceInfo);
    setConfirmLoading(false);
  };

  // 获取添加企业的企业信息
  useEffect(() => {
    getComSpace();
    console.log('翻页回调');
  }, [page, size]);

  // 打开转移企业空间
  const [openTransComSpace, setOpenTransComSpace] = useState(false);
  const [ownerInfo, setOwnerInfo] = useState({
    enterpriseId: '',
    ownerPhone: '',
    ownerName: '',
  });
  const handleTransOK = async () => {
    const res = await api.transmitEnterpriseApi(ownerInfo);
    console.log('转移企业空间', res);
    if (res.code === 200) {
      message.success('企业空间拥有者转移成功');
    } else {
      message.error('转移企业失败');
    }
    getComSpace();
    setOpenTransComSpace(false);
  };
  const handleTransCancel = () => {
    setOpenTransComSpace(false);
  };

  // 打开创建授权码
  const [openCreateAuthorization, setOpenCreateAuthorization] = useState(false);
  const [purchaseNum, setPurchaseNum] = useState(0);
  const [durationNum, setDurationeNum] = useState(0);
  const [comSpaceId, setComSpaceId] = useState('');
  const [ownProjectApplications, setOwnProjectApplications] = useState([]);
  const [comName, setComName] = useState('');

  // 授权码信息储存
  const [auCodeInfo, setAuCodeInfo] = useState();

  // 成功创建授权码弹窗
  const [openSuccessCreateAuCode, setOpenSuccessCreateAuCode] = useState(false);
  const handleAuCodeOK = async (timeUnite: string = 'month') => {
    const res = await api.createAuthorizationCode({
      enterpriseWorkspaceId: comSpaceId,
      expireDuration: durationNum,
      num: purchaseNum,
      ownProjectApplications: ownProjectApplications,
      timeUnite,
    });
    console.log('创建授权码', res);
    if (res.code === 200 && res.success) {
      setAuCodeInfo(res.data?.details);
      setOpenCreateAuthorization(false);
      setOpenSuccessCreateAuCode(true);
    } else {
      setOpenCreateAuthorization(false);
      message.error('创建授权码失败');
    }
  };
  const handleAuCodeCancel = () => {
    setOpenCreateAuthorization(false);
  };
  // 成功创建授权码弹窗中，返回列表
  const backToEnterpriseList = () => {
    console.log('返回列表');
    setOpenSuccessCreateAuCode(false);
    setOpenAuCodeList(false);
    getComSpace();
  };

  // 查看授权码弹窗
  const [openAuCodeList, setOpenAuCodeList] = useState(false);
  const handleAuCodeListCancel = () => {
    setOpenAuCodeList(false);
  };

  // 获取授权码权限列表
  // const [defaultCheckedList, setDefaultCheckedList] = useState(['']);
  // const getPerList = async () => {
  //   const res = await api.getPermissionsList('2');
  //   console.log('获取授权码权限列表', res);
  //   if (res.code === 200 && res.success) {
  //     let auCodeArray: any = [];
  //     res.data.details.map((item: any) => {
  //       auCodeArray.push({
  //         label: item.name,
  //         value: item.code,
  //       });
  //     });
  //     auCodeArray[0].disabled = true;
  //     setDefaultCheckedList([auCodeArray[0].value]);
  //   } else {
  //     message.error('获取项目级权限列表失败');
  //   }
  // };

  return (
    <>
      <div className="wrap">
        {data.length > 0 || (data.length == 0 && inputValue.current !== undefined) ? (
          <div className="headerBar">
            <Input
              style={{ width: 350 }}
              prefix={<SearchOutlined />}
              allowClear
              onChange={onInputChange}
              // onBlur={() => searchUsers(inputValue.current)}
              onPressEnter={() => searchUsers(inputValue.current)}
              placeholder="搜索企业空间名称、所属公司、手机号"
            />
            <div>
              <Button
                type="primary"
                ghost={false}
                onClick={() => {
                  setAddTitle('新增企业空间');
                  setUpdateComSpaceInfo(undefined);
                  setOpenAddCompony(true);
                }}
                style={{ marginRight: 16 }}
              >
                新增企业空间
              </Button>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="memberTable">
          <Spin spinning={tableLoad}>
            {data.length > 0 ? (
              <Table
                rowKey="usersId"
                columns={columns}
                dataSource={data}
                pagination={{
                  size: 'small',
                  showTotal: (total, range) => {
                    return `${range[0]}-${range[1]}条，共${total}条`;
                  },
                  showTitle: true,
                  showQuickJumper: false,
                  showSizeChanger: true,
                  total: total, // 数据总数
                  pageSize: size, // 每页数量
                  defaultPageSize: size,
                  current: page, // 当前页数
                  defaultCurrent: page,
                  onChange: (p, s) => {
                    console.log('翻页', { p, s });
                    setPage(p as number);
                    setSize(s as number);
                  },
                }}
                scroll={{ x: 1500, y: 'calc(100vh - 468px)' }}
              />
            ) : (
              <div className="emptyInfo">
                {/* <IconFont className={styles.emptyImage} type="icon-kong" /> */}
                {/* <img src={EmptyIcon} className="emptyImage" /> */}
                {/* <EmptyFileColor /> */}
                {/* <div className={styles.emptyBody}>没有企业空间</div> */}
                <PtxEmpty
                  isEmpty={!inputValue.current}
                  describe="没有企业空间"
                  icon={<EmptyFileColor />}
                  btnRender={() => {
                    if (inputValue.current) {
                      return undefined;
                    }
                    return (
                      <Button type="primary" className="emptyFooter">
                        <span
                          className="link"
                          onClick={() => {
                            setAddTitle('新增企业空间');
                            setOpenAddCompony(true);
                          }}
                          style={{ margin: '0 4px' }}
                        >
                          新增企业空间
                        </span>
                      </Button>
                    );
                  }}
                />
              </div>
            )}
          </Spin>
        </div>
      </div>
      {/* 添加企业空间 */}
      {openAddCompony && (
        <AddComSpace
          handleOK={handleOk}
          handleCancel={handleCancel}
          tableData={data}
          comSpaceInfo={comSpaceInfo}
          setComSpaceInfo={setComSpaceInfo}
          confirmLoading={confirmLoading}
          addTitle={addTitle}
          updateComSpaceInfo={updateComSpaceInfo}
        />
      )}
      {/* 编辑企业空间 */}
      {openUpdateCompony && (
        <UpdateComSpace
          handleOK={handleUpdateOk}
          handleCancel={handleCancel}
          tableData={data}
          comSpaceInfo={comSpaceInfo}
          setComSpaceInfo={setComSpaceInfo}
          confirmLoading={confirmLoading}
          addTitle={addTitle}
          updateComSpaceInfo={updateComSpaceInfo}
          optionsNum={optionsNum}
          perList={perList}
        />
      )}
      {/* 转移企业空间 */}
      {openTransComSpace && (
        <TransmitComSpace
          handleTransOK={handleTransOK}
          handleTransCancel={handleTransCancel}
          ownerInfo={ownerInfo}
          setOwnerInfo={setOwnerInfo}
        />
      )}
      {/* 创建授权码 */}
      {openCreateAuthorization && (
        <CreateAuthorization
          handleAuCodeOK={handleAuCodeOK}
          handleAuCodeCancel={handleAuCodeCancel}
          setPurchaseNum={setPurchaseNum}
          setDurationeNum={setDurationeNum}
          setOwnProjectApplications={setOwnProjectApplications}
          comName={comName}
          // defaultCheckedList={defaultCheckedList}
          units={units}
        />
      )}
      {/* 成功创建授权码 */}
      {openSuccessCreateAuCode && (
        <SuccessCreateAuCode
          handleCancel={backToEnterpriseList}
          auCodeInfo={auCodeInfo}
          data={data}
        />
      )}
      {/* 查看授权码 */}
      {openAuCodeList && (
        <AuCodeList
          handleAuCodeListCancel={handleAuCodeListCancel}
          enterpriseWorkspaceId={comSpaceId}
          setOpenCreateAuthorization={setOpenCreateAuthorization}
          units={units}
        />
      )}
    </>
  );
};

export default ComponySpaceList;
